import { NSARouterMakerResult } from "namirasoft-account-react";
import { SecretCreateRow, SecretRow } from "namirasoft-secret";
import { useState } from "react";
import RetrieveValueDialog from "../components/RetrieveValueDialog";
import { SecretEntities } from "../SecretEntities";
import { SecretLayout } from "../SecretLayout";
import { SecretRouterProps } from "../SecretRouterProps";

interface SecretListPageProps extends NSARouterMakerResult, SecretRouterProps
{ }

interface SecretListPageState
{
	show_retrieve_value: boolean;
	secret_id: string;
}

function SecretListPage(props: SecretListPageProps)
{
	let [state, setState] = useState<SecretListPageState>({ show_retrieve_value: false, secret_id: "" });

	return (
		<>
			<SecretLayout<SecretRow, SecretCreateRow> {...props}
				action={{
					title: "Secret List",
					description: "This section shows your stored secrets and allows authorized accounts to retrieve secrets that are retrievable. You can also search and filter the list.",
					menus: {}
				}}
				pages={{
					entity: SecretEntities.secret(props, (id) =>
					{
						setState(prevState => ({ ...prevState, show_retrieve_value: true, secret_id: id }));
					}),
					list: {}
				}}
			>
				<></>
			</SecretLayout>

			{
				state.show_retrieve_value &&
				<RetrieveValueDialog
					{...props}
					id={state.secret_id}
					onClose={() =>
					{
						setState(prevState => ({ ...prevState, show_retrieve_value: false }));
					}}
				/>
			}
		</>
	);
}

export default SecretListPage;